<template>
    <div style="position: relative;" v-if="show" :class="classObj" ref="triggerWrap">
        <div class="language" @click.stop="onShowLangPopup">
            <div class="language_icon" v-if="showIcon">
                <img mode="aspectFill" :src="langImg" />
            </div>
            <slot name="langType"></slot>
        </div>
        <div v-if="isShowLangPopup" ref="portalRoot" class="lang_portal">
            <div class="mask" @click.stop="isShowLangPopup = false"></div>
            <div class="lang_content" :style="popupStyle">
                <div class="header">
                    <div>{{ $t("lang.ChangeLanguage") }}</div>
                    <div class="close" @click.stop="isShowLangPopup = false">
                        <i class="iconfont icon-s-cuowu-guanbi"></i>
                    </div>
                </div>
                <div class="langs">
                    <div v-for="(item, index) in langList" :key="index" class="outset_item"
                        :class="{ 'act': langType === item.type }" @click.stop="onSelLang(item.type)">
                        <div class="langs__item">
                            <div class="langs__item__img">
                                <van-image width="25px" height="25px" radius="50%" mode="aspectFill"
                                    :src="item.img"></van-image>
                            </div>
                            <div class="txt">{{ item.name }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
    name: 'language',
    data() {
        return {
            isShowLangPopup: false,
            langList: [],
            popupStyle: {}
        }
    },
    computed: {
        langType() {
            return this.$store.getters.language
        },
        langImg() {
            if (this.BelongNation === 'Nigeria') return require('@/assets/lang/Nigeria.jpeg')
            return this.langObj[this.langType]?.img || ''
        },
        ...mapState({
            device: state => state.app.device
        }),
        classObj() {
            return {
                mobile: this.device === 'mobile'
            }
        }
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
        showIcon: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        isShowLangPopup(val) {
            if (val) {
                this.$nextTick(() => {
                    this.ensurePortalInBody()
                    this.updateLangPopupPosition()
                })
            }
        }
    },
    created() { },
    beforeDestroy() {
        const portal = this.$refs.portalRoot
        if (portal && portal.parentNode === document.body) {
            document.body.removeChild(portal)
        }
    },
    methods: {
        onShowLangPopup() {
            if (this.disabled || this.DisabledBelongCountry === 'disable') return
            const configured = this.$store.getters.sysConfig?.countryList
            const keys = configured ? configured.split(',').map(key => key.trim()) : Object.keys(this.langObj || {})
            this.langList = keys.map(key => this.langObj[key]).filter(Boolean)
            this.isShowLangPopup = this.langList.length > 0
            this.popupStyle = {}
        },
        onSelLang(type) {
            this.$store.dispatch('system/setLanguage', type)
            this.$store.dispatch('system/setUserSetLanguage', type)
            this.$i18n.locale = type
            this.isShowLangPopup = false
            this.onPageRefreshInLang()
            this.$emit('confirm')
        },
        ensurePortalInBody() {
            const portal = this.$refs.portalRoot
            if (portal && portal.parentNode !== document.body) {
                document.body.appendChild(portal)
            }
        },
        updateLangPopupPosition() {
            if (!this.isShowLangPopup) return
            const trigger = this.$refs.triggerWrap
            const portal = this.$refs.portalRoot
            if (!trigger || !portal) return
            const rect = trigger.getBoundingClientRect()
            const popupWidth = Math.min(264, window.innerWidth - 24)
            const popupMaxHeight = Math.min(384, window.innerHeight - 24)
            const popupHeight = Math.min(portal.querySelector('.lang_content')?.offsetHeight || 72 + this.langList.length * 82, popupMaxHeight)
            const left = Math.max(12, Math.min(rect.left, window.innerWidth - popupWidth - 12))
            const below = rect.bottom + 8
            const top = below + popupHeight <= window.innerHeight - 12 ? below : Math.max(12, rect.top - popupHeight - 8)
            this.popupStyle = { position: 'fixed', zIndex: 5002, left: left + 'px', top: top + 'px', width: popupWidth + 'px', maxHeight: popupMaxHeight + 'px' }
        },
        onPageRefreshInLang() {
            if (this.$route.path.indexOf('/Home') !== -1) {
                const opt = this.$route?.query
                if (opt && opt.token) {
                    console.log('token已经过期')
                    this.$router.replace({
                        path: '/'
                    })
                }
                window.location.reload()
            } else if (this.$route.path.indexOf('/Sports') !== -1) {
                window.location.reload()
            } else {
                this.$router.replace({
                    path: '/'
                })
            }
            this.$store.dispatch('system/setIsShowSport', false)
        }
    }
}
</script>

<style scoped lang="scss">
@import '@/common/styles/viriables.scss';
.language {
    // width: .64rem;
    // padding: 0 .1rem;
    height: .64rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 1001;

    .language_icon {
        width: .42rem;
        height: .42rem;
        border-radius: 50%;

        &>img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
            overflow: hidden;
            vertical-align: top;
        }
    }
}

.mask {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, .55);
    z-index: 5000;
}

.lang_portal {
    position: fixed;
    inset: 0;
    z-index: 5000;
}

.lang_content {
    box-sizing: border-box;
    width: min(3.3rem, calc(100vw - .48rem));
    background: var(--aurora-soft-gradient);
    border: .01rem solid var(--aurora-line);
    border-radius: .22rem;
    position: fixed;
    top: 0;
    left: 0;
    transform: none;
    z-index: 5001;
    min-height: 1.5rem;
    max-height: min(4.8rem, calc(100vh - 1.2rem));
    overflow: hidden;
    box-shadow: 0 .18rem .5rem var(--aurora-shadow-color), 0 0 .2rem var(--aurora-shadow-color);
    backdrop-filter: blur(8px);

    .header {
        text-align: left;
        color: var(--aurora-ink);
        font-size: .24rem;
        font-weight: 700;
        position: relative;
        padding: .18rem .2rem .14rem;
        border-bottom: 1px solid var(--aurora-line);

        i {
            position: absolute;
            top: .14rem;
            right: .18rem;
            font-size: .28rem;
            color: var(--aurora-ink);
            cursor: pointer;
        }

        .close {
            position: absolute;
            top: 0;
            right: 0;
            width: .56rem;
            height: .56rem;
        }
    }

    .langs {
        padding: .1rem;
        overflow-y: auto;
        max-height: min(4rem, calc(100vh - 1.8rem));

        .outset_item {
            border-radius: .16rem;
            overflow: hidden;

            .langs__item {
                width: 100%;
                min-height: .72rem;
                background: var(--aurora-soft-gradient);
                display: flex;
                align-items: center;
                padding: 0 .18rem;
                cursor: pointer;
                box-sizing: border-box;
                border: 1px solid var(--aurora-line);
                box-shadow: inset 0 1px 0 var(--aurora-shadow-color);
                transition: background .2s ease, border-color .2s ease, box-shadow .2s ease, transform .2s ease;

                &__img {
                    width: .42rem;
                    height: .42rem;
                    margin-right: .16rem;
                    flex-shrink: 0;
                }

                .txt {
                    font-style: normal;
                    font-weight: 600;
                    font-size: .2rem;
                    color: var(--aurora-ink);
                    line-height: 1.2;
                }
            }

            & + .outset_item {
                margin-top: .1rem;
            }

            &:hover {
                .langs__item {
                    border-color: var(--aurora-accent);
                    background: var(--aurora-lilac);
                    box-shadow: 0 0 .14rem var(--aurora-shadow-color), inset 0 1px 0 var(--aurora-shadow-color);
                }
            }

            &.act {
                .langs__item {
                    background: var(--aurora-lilac);
                    border-color: var(--aurora-accent);
                    box-shadow: 0 0 .2rem var(--aurora-shadow-color), inset 0 1px 0 var(--aurora-shadow-color);
                }

                .txt {
                    color: var(--aurora-accent);
                }
            }
        }
    }
}
</style>
